export const defaultStateStoriaClinicaRsa = {
    // --- Sezione Storia Clinica ---
    anamnesiPatologica: '',
    dataInizio: '',
    dataFine: '',
    codDiagnosi: '',
    diagnosi: '',
    cronicita: '',
    cronicitaLabel: '',

    // --- Sezione Storia Familiare ---
    anamnesiFamiliare: '',
    diagnosisValue: '',
    diagnosisDisplayName: '',
    diagnosisId: '0',
    diagnosisAge: '0',
    diagnosisAgeUnit: 'a',
    ageUnitLabel: 'anni',
    deathAge: '0',
    deathAgeUnit: 'a',
    deathAgeUnitLabel: 'anni',
    gradoDiParentela: 'MTH',
    gradoDiParentelaDescrizione: 'Madre',
    sesso: 'F',
};

export const storiaClinicaRsaModified = (storiaClinica) => {
    return Object.keys(defaultStateStoriaClinicaRsa)
        .filter((key) => defaultStateStoriaClinicaRsa[key] === '')
        .some((key) => storiaClinica[key] !== '');
}

export const terapiaAttualeModified = (terapiaAttuale) => {
    if (terapiaAttuale) {
        if (Array.isArray(terapiaAttuale)) {
            return terapiaAttuale.length > 0;
        }
        if (typeof terapiaAttuale === "string") {
            return (terapiaAttuale || "").trim() !== "";
        }
    }
    return false;
};

export const esameObiettivoModified = (esameObiettivo) => {
    return (esameObiettivo || "").trim() !== "";
};

export const confrontoEsamiPrecModified = (confrontoEsamiPrec) => {
    return (confrontoEsamiPrec || "").trim() !== "";
};

export const quesitoDiagnosticoModified = (diagnosi) => {
    if (diagnosi && typeof diagnosi === 'object') {
        const hasQuesito = (diagnosi.quesito || "").trim() !== "";
        const hasItems = Array.isArray(diagnosi.items) && diagnosi.items.length > 0;
        return hasQuesito || hasItems;
    }
    return false;
};

export const accertamentiConsigliatiModified = (accertamenti) => {
    if (accertamenti) {
        if (Array.isArray(accertamenti)) {
            return accertamenti.length > 0;
        }
        if (typeof accertamenti === "string") {
            return (accertamenti || "").trim() !== "";
        }
    }
    return false;
};

export const terapiaFarmacologicaModified = (terapia) => {
    if (!terapia.dataInizioTerapia || !terapia.dataFineTerapia) return false;
    return (terapia.dataFineTerapia > terapia.dataInizioTerapia) && terapia.farmaci.length > 0;
};